<!--class="filter-btn btn btn-outline-primary btn-lg me-2"-->
<form id="product-filter"
      [formGroup]="filterSelection">
  <div class="border-bottom pb-3">
    <h3 class="fw-normal mb-3">Browse by</h3>
    <div class="btn-group btn-group-toggle mb-3" data-toggle="buttons">
      <label class="filter-btn btn btn-outline-primary btn-lg me-2"
             *ngFor="let tab of filterTabs"
             [ngClass]="{'active': filterSelection.value.tab === tab}">
        <input type="radio"
               name="tab"
               formControlName="tab"
               [value]="tab">
        {{tab}}
      </label>
    </div>
  </div>

  <div id="product-filter-licensetype"
       class="mt-4"
       *ngIf="filterSelection.value.tab === Tab.LicenseType">
    <h3 class="fw-normal mb-3">License type</h3>
    <div class="btn-group btn-group-toggle mb-3" data-toggle="buttons">
      <label class="filter-btn btn btn-outline-primary btn-lg me-2"
             *ngFor="let licenseType of licenseTypes;"
             [ngClass]="{'active': filterSelection.value.licenseTypeChoice === licenseType}">
        <input type="radio"
               name="licenseTypeChoice"
               formControlName="licenseTypeChoice"
               [value]="licenseType">
        {{licenseType}}
      </label>
    </div>
  </div>

  <div id="product-filter-platform"
       class="mt-4"
       *ngIf="filterSelection.value.tab === Tab.Platform">
    <h3 class="fw-normal mb-3">Platform</h3>
    <div class="btn-group btn-group-toggle mb-3" data-toggle="buttons">
      <label class="filter-btn btn btn-outline-primary btn-lg me-2"
             *ngFor="let platform of platforms;"
             [ngClass]="{'active': filterSelection.value.platformChoice === platform}">
        <input type="radio"
               name="platformChoice"
               formControlName="platformChoice"
               [value]="platform">
        {{platform}}
      </label>
    </div>
  </div>
</form>
